<template>
  <div class="con">
    <!-- title -->
    <div class="title">
      <img class="title_bg" src="../assets/top2x.png" alt="">
      <div class="logo_box">
        <img class="logo_img" src="../assets/logo.png" alt="">
      </div>
      <div class="title_about">
        <div class="border"></div>
        <div class="about">主题征文活动报名表</div>
        <div class="border"></div>
      </div>
      <!-- 表格 -->
      <div class="table_box">
        <div class="table_title">
          作品名称
        </div>
        <div class="table_content">
          <van-field v-model="articleName" placeholder="请输入您的作品名称" maxlength="200" />
        </div>
        <div class="table_title">
          作者姓名
        </div>
        <div class="table_content">
          <van-field v-model="name" placeholder="请输入您的姓名" maxlength="50" />
        </div>
        <div class="table_title">
          年龄
        </div>
        <div class="table_content">
          <van-field v-model="age" placeholder="请输入您的年龄" type="number" maxlength="3" />
        </div>
        <div class="table_title">
          单位
        </div>
        <div class="table_content">
          <van-field v-model="company" placeholder="请输入您的单位" maxlength="100" />
        </div>
        <div class="table_title">
          电话
        </div>
        <div class="table_content">
          <van-field v-model="phone" placeholder="请输入您的电话" maxlength="20" />
        </div>
        <div class="table_title">
          地址
        </div>
        <div class="table_content">
          <van-field v-model="address" placeholder="请输入您的地址" maxlength="255" />
        </div>
        <div class="table_title">
          上传作品
        </div>
        <div class="upload_box">
          <div v-if="!fileStatus">
            <van-uploader :after-read="afterRead" :before-read="beforeRead" v-model="fileList" :max-count="1"
              max-size="5242880" @oversize="oversize" accept=".doc,.docx" :preview-image="false">
              <div class="upload_box_content">
                <div class="upload_box_content_text">+&nbsp;&nbsp;点击上传</div>
              </div>
            </van-uploader>
          </div>
          <div v-else>
            <div class="upload_box_content">
              <div class="upload_box_content_text">{{ fileName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文章解释 -->
    <div class="upload_about">注*作品以Word文档形式提交，标题为方正小标宋简体，字号为2号，内文为仿宋_GB2312，字号为3号，行距为固定值28磅。</div>
    <!-- 按钮 -->
    <div class="upload_button" @click="submit">
      <img src="../assets/submit2x.png" alt="">
      <!-- <div class="upload_button_text">提交</div> -->
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: '',
  components: {
  },
  props: {},
  data() {
    return {
      fileStatus: false,//上传状态
      fileName: '',//上传的文件名
      fileList: [],
      address: '', //地址
      filePath: '', //文件上传路径
      phone: '', //手机号
      name: '', //姓名
      articleName: '', //文章名
      age: '', //年龄
      company: '', //单位
      tijiaoStatus: false, //当前页面是否提交过
      tijiaoLoading: false //防抖
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    afterRead(file) {
      Toast.loading({
        mask: true,
        message: '上传中...',
        duration: 0
      });
      // 此时可以自行将文件上传至服务器
      console.log(file, 'llll');
      let that = this;
      let params = new FormData();
      params.append("file", file.file);
      let config = {
        headers: {
          //添加请求头
          "Content-Type": "multipart/form-data"
        }
      };
      this.$axios
        .post("/common/uploadNew", params, config)
        .then((res) => {
          Toast.clear()
          if (res.code != 200) {
            // Toast.fail('上传失败！')
            Toast({
              message: '上传失败！',
              duration: 2000,
              type: 'fail',
              position: 'top'
            })

          } else {
            // Toast.success('上传成功')
            Toast({
              message: '上传成功！',
              duration: 2000,
              type: 'success',
              position: 'top'

            })
            // console.log(res, "vvvv");
            that.fileStatus = true
            that.fileName = file.file.name
            that.filePath = res.fileName
          }
        }).catch((err) => {
          Toast.clear()
          // Toast.fail('上传失败！')
          Toast({
            message: '上传失败了！',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
        })
    },
    // 返回布尔值
    beforeRead(file) {
      console.log(file);
      if (file.name.toLowerCase().endsWith('.docx') || file.name.toLowerCase().endsWith('.doc')) {

        return true;
      } else {
        Toast('请上传.doc或.docx格式文件');
        return false;
      }
    },
    oversize(file) {
      Toast.fail('上传文件最大支持5M，\n请调整文件大小再试!')
      return false;
    },
    // 提交
    submit() {
      
      if (this.tijiaoStatus || this.tijiaoLoading) {
        Toast({
          message: '请勿重复提交',
          duration: 2000,
          type: 'fail',
          position: 'top'
        })
      } else {
        
        if (this.articleName.length == 0) {
          Toast({
            message: '请输入您的作品名称',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          
          // Toast.fail('请输入您的作品名称');
          return;
        }
        if (this.name.length == 0) {
          Toast({
            message: '请输入您的作品姓名',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请输入您的作品姓名');
          return;
        }
        if (this.age.length == 0) {
          Toast({
            message: '请输入您的年龄',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请输入您的年龄');
          return;
        }
        if (this.company.length == 0) {
          Toast({
            message: '请输入您的单位',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请输入您的单位');
          return;
        }
        if (this.phone.length == 0) {
          Toast({
            message: '请输入您的电话',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请输入您的电话');
          return;
        }
        if (this.phone.length !== 11) {
          Toast({
            message: '请输入11位电话号',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请输入您的电话');
          return;
        }
        if (this.address.length == 0) {
          Toast({
            message: '请输入您的地址',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请输入您的地址');
          return;
        }
        if (this.filePath.length == 0) {
          Toast({
            message: '请上传您的文件',
            duration: 2000,
            type: 'fail',
            position: 'top'
          })
          // Toast.fail('请上传您的文件');
          return;
        }
        this.tijiaoLoading =true
        this.$axios
          .post("/system/info/insert", {
            address: this.address, //地址
            filePath: this.filePath, //文件上传路径
            phone: this.phone, //手机号
            name: this.name, //姓名
            articleName: this.articleName, //文章名
            age: this.age, //年龄
            company: this.company, //单位
          }).then((res) => {
            if (res.code != 200) {
              // Toast.fail(res.msg)
              Toast({
                message: res.msg,
                duration: 2000,
                type: 'fail',
                position: 'top'
              })
              
              this.tijiaoLoading =false
              // Toast({
              //   message: '您已提交成功，\n请勿重复提交',
              //   duration: 2000,
              //   type: 'fail',
              //   position: 'top'
              // })

            } else {
              // Toast.success('提交成功')
              Toast({
                message: '您已提交成功',
                duration: 2000,
                type: 'success',
                position: 'top'
              })
              this.tijiaoStatus = true
              this.tijiaoLoading =false
            }
          }).catch((err) => {
            // Toast.fail('提交失败了，\n请稍后再试!')
            Toast({
              message: '提交失败了，\n请稍后再试!',
              duration: 2000,
              type: 'fail',
              position: 'top'
            })
            this.tijiaoLoading =false
          });
      }

    },

  }
}
</script>

<style scoped lang="less">
/deep/.van-field__control {
  border: none;
  height: 40px;
  padding: 10px 12px 9px;
  box-sizing: border-box;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  // color: #cccccc;
  text-align: justified;
  font-style: normal;
  text-transform: none;
}

/deep/.van-cell {
  padding: 0;
}

.con {
  background-color: #c71f1f;
  position: relative;
  width: 375px;
  height: 1013px;
  overflow: hidden;
  margin: 0 auto;

  .title {
    position: relative;
    width: 375px;
    height: 814px;
    overflow: hidden;
    margin: 0;
    padding: 0;

    .title_bg {
      width: 100%;
      height: 100%;
    }

    .logo_box {
      width: 61px;
      height: 61px;
      overflow: hidden;
      position: absolute;
      top: 19px;
      left: 50%;
      transform: translateX(-50%);

      .logo_img {
        width: 100%;
        height: 100%;
      }
    }

    .title_about {
      width: 282px;
      height: 27px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      top: 164px;
      left: 50%;
      transform: translateX(-50%);

      .border {
        width: 52px;
        height: 0px;
        border: 1px solid #ffffff;
      }

      .about {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        text-align: justified;
        font-style: normal;
        text-transform: none;
      }
    }

    .table_box {
      width: 327px;
      height: 605px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      box-sizing: border-box;
      padding: 20px;
      overflow: hidden;
      position: absolute;
      top: 209px;
      left: 50%;
      transform: translateX(-50%);

      .table_title {
        width: 100%;
        height: 21px;
        line-height: 21px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px !important;
        color: #000000;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .table_content {
        width: 287px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid rgba(199, 31, 31, 0.2);
        overflow: hidden;
        margin-top: 6px;
        margin-bottom: 16px;
        box-sizing: border-box;
      }

      .upload_box {
        width: 287px;
        height: 40px;
        margin-top: 6px;
        border-radius: 4px 4px 4px 4px;
        border: 1px dashed rgba(199, 31, 31, 0.6);
        box-sizing: border-box;

        .upload_box_content {
          width: 285px;
          height: 40px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          line-height: 38px;
          color: #c71f1f;
          font-style: normal;
          text-transform: none;
          position: relative;

          .upload_box_content_text {
            width: 285px;
            height: 38px;
            text-align: center;
            overflow: hidden;
            // position: absolute;
            // left: 50%;
            // transform: translateX(-50%);
          }
        }
      }
    }
  }

  // 文章
  .upload_about {
    width: 327px;
    height: 79px;
    border-radius: 4px 4px 4px 4px;
    border: 2px solid #fad5b0;
    padding: 8px 16px;
    box-sizing: border-box;
    position: absolute;
    top: 843px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fad5b0;
    text-align: justified;
    font-style: normal;
    text-transform: none;
  }

  .upload_button {
    width: 338px;
    height: 54px;
    position: absolute;
    top: 951px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }

    .upload_button_text {
      line-height: 54px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #c71f1f;
      text-align: justified;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>